var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-layout",
    {
      attrs: {
        size: "narrow",
        title: _vm.Resources.BackerCenter.SectionPaymentsHeader,
        "current-view": "payments",
      },
    },
    [
      _c("filter-view", {
        attrs: {
          filters: _vm.paymentsFilters,
          "hidden-filter-keys": ["searchType"],
          "hidden-selected-keys": ["searchType"],
          "filter-list-title": _vm.Resources.Search.SearchFiltersHeader,
          "sort-list-title": _vm.Resources.Search.SearchProjectSortTitle,
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function ({ filters, onFilterChange }) {
              return [
                _c("backer-center-payments-tabs", {
                  staticClass: "_mb-4",
                  attrs: {
                    "current-search-type":
                      filters.searchParams.value.searchType,
                  },
                  on: {
                    "tab-selected": (type) =>
                      onFilterChange("searchType", type),
                  },
                }),
              ]
            },
          },
          {
            key: "default",
            fn: function ({
              items,
              isProcessing,
              canLoadMore,
              loadMore,
              isLoadingMore,
            }) {
              return [
                _c(
                  "box",
                  {
                    staticClass: "_flexcol _separated--x _separated--light",
                    attrs: { content: "" },
                  },
                  [
                    isProcessing
                      ? _vm._l(3, function (n) {
                          return _c("backer-center-payments-skeleton", {
                            key: `skeleton:${n}`,
                          })
                        })
                      : _vm.hasPayments
                      ? [
                          _vm._l(items, function (payment) {
                            return _c(
                              "backer-center-payments-card",
                              _vm._b(
                                {
                                  key: payment.paymentID,
                                  attrs: {
                                    "search-type":
                                      _vm.paymentsFilters.searchParams.value
                                        .searchType,
                                  },
                                },
                                "backer-center-payments-card",
                                payment,
                                false
                              )
                            )
                          }),
                          _vm._v(" "),
                          isLoadingMore
                            ? _vm._l(3, function (n) {
                                return _c("backer-center-payments-skeleton", {
                                  key: `skeleton:${n}`,
                                })
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          canLoadMore
                            ? _c("load-more-trigger", {
                                on: { "load-more": loadMore },
                              })
                            : _vm._e(),
                        ]
                      : _c("empty-state", {
                          attrs: {
                            title:
                              _vm.Resources.BackerCenter
                                .PaymentsEmptyStateHeader,
                            description:
                              _vm.Resources.BackerCenter
                                .PaymentsEmptyStateParagraph,
                            "data-qa": "backer-center-view-payments:EmptyState",
                          },
                        }),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }